import { render, staticRenderFns } from "./SuperAdminModules.vue?vue&type=template&id=79d3cc26&scoped=true&"
import script from "./SuperAdminModules.vue?vue&type=script&lang=js&"
export * from "./SuperAdminModules.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminModules.vue?vue&type=style&index=0&id=79d3cc26&lang=scss&scoped=true&"
import style1 from "./SuperAdminModules.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d3cc26",
  null
  
)

export default component.exports